export default "__VITE_ASSET__6cc11440__"